"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOL_ID_TO_RP_CONTEXT_TYPE = exports.ACTIVITY_VARIANTS = void 0;
var _alloyProvider = require("@adsk/alloy-provider");
const ACTIVITY_VARIANTS = exports.ACTIVITY_VARIANTS = {
  ADDED: "added",
  REMOVED: "removed"
};
const TOOL_ID_TO_RP_CONTEXT_TYPE = exports.TOOL_ID_TO_RP_CONTEXT_TYPE = {
  [_alloyProvider.TOOL_IDS.ASSETS]: "asset",
  [_alloyProvider.TOOL_IDS.DOCUMENTS]: "doc",
  [_alloyProvider.TOOL_IDS.FORMS]: "form",
  [_alloyProvider.TOOL_IDS.PHOTOS]: "photo",
  [_alloyProvider.TOOL_IDS.SHEETS]: "sheet"
};
//# sourceMappingURL=constants.js.map